import { render, staticRenderFns } from "./BulkSendsCardTable.vue?vue&type=template&id=734c982a&lang=pug"
import script from "./BulkSendsCardTable.vue?vue&type=script&lang=js"
export * from "./BulkSendsCardTable.vue?vue&type=script&lang=js"
import style0 from "./BulkSendsCardTable.vue?vue&type=style&index=0&id=734c982a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports